import React, { useEffect, useState } from "react";
import { BaseUrlApi, ErrorMessage } from "../../../../../../lib/api";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { TeacherCard } from "./TeacherCard";
import { toast } from "sonner";
import { Button } from "../../../../../../components/ui/button";

export default function TeacherStep({
  course,
  selectedTeacher,
  handleTeacherSelect,
  setCurrentStep,
}) {
  const [teachers, setTeachers] = useState([]);
  //   const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [loadingTeachers, setLoadingTeachers] = useState(true);
  const [teacherError, setTeacherError] = useState(null);

  const getTeachers = async () => {
    try {
      const { data } = await axios.get(
        `${BaseUrlApi}/enroll-course/teacher/course/${course.id}`
      );
      setTeachers(data.data);
    } catch (error) {
      setTeacherError("Failed to load teachers. Please try again later.");
      toast("Error", { description: ErrorMessage(error) });
    } finally {
      setLoadingTeachers(false);
    }
  };
  useEffect(() => {
    setLoadingTeachers(true);
    getTeachers();
  }, []);

  return (
    <section className="mb-16">
      <h2 className="text-2xl font-bold mb-6">Select a Teacher</h2>
      {loadingTeachers ? (
        <div className="flex justify-center items-center h-64">
          <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
        </div>
      ) : teacherError ? (
        <div className="p-4 rounded-xl border border-destructive bg-destructive/40 mb-4 text-destructive-foreground">
          {teacherError}
        </div>
      ) : !teachers.length ? (
        <div className="text-center p-12 border rounded-lg">
          <h3 className="text-lg font-medium">
            No teachers available for this course
          </h3>
          <p className="text-muted-foreground mt-2">
            Please try another course
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {teachers.map((teacher) => (
            <TeacherCard
              teacher={teacher}
              isSelected={selectedTeacher?.user?.id === teacher?.user?.id}
              onSelect={() => handleTeacherSelect(teacher)}
            />
          ))}
        </div>
      )}
      {/* Navigation */}
      <div className="mt-4 flex items-center justify-between gap-2 flex-wrap">
        <Button
          variant="outline"
          onClick={() => setCurrentStep(0)}
          className="w-full sm:w-fit"
        >
          Back to Level
        </Button>
      </div>
    </section>
  );
}
